export default [
  {
    component: () => import("pages/CopyrightReportList.vue"),
    meta: {
      accessLevel: "copyright_reporting",
      title: "Copyright Reports",
    },
    name: "copyright-reports",
    path: "/copyright_reports",
    props: true,
  },
  {
    component: () => import("pages/CopyrightReportEdit.vue"),
    meta: {
      accessLevel: "copyright_reporting",
      title: "New Copyright Reports",
    },
    name: "copyright-report-new",
    path: "/copyright_reports/new",
    props: true,
  },
  {
    component: () => import("pages/reports/FrontPages/FrontPageReports.vue"),
    meta: {
      title: "Front Page Reports",
    },
    name: "front-page-reports",
    path: "/front_page_reports",
    props: (route) => ({
      tab: route.query.tab,
    }),
  },
  {
    component: () =>
      import("pages/reports/FrontPages/EditFrontPageReportSchedule.vue"),
    meta: {
      title: "New Front Page Report Schedule",
    },
    name: "front-page-report-schedule-new",
    path: "/front_page_report_schedules/new",
  },
  {
    component: () =>
      import("pages/reports/FrontPages/EditFrontPageReportSchedule.vue"),
    meta: {
      title: "Edit Front Page Report Schedule",
    },
    name: "front-page-report-schedule-edit",
    path: "/front_page_report_schedules/:scheduleId",
    props: true,
  },
  {
    component: () => import("pages/reports/SocialReportsList.vue"),
    meta: {
      title: "Social Reports",
    },
    name: "social-reports",
    path: "/social_reports",
    props: true,
  },
  {
    component: () => import("pages/reports/SocialReportEdit.vue"),
    meta: {
      title: "New Social Report",
    },
    name: "social-report-new",
    path: "/social_reports/new",
  },
  {
    component: () => import("pages/reports/SocialReportEdit.vue"),
    meta: {
      title: "Edit Social Report",
    },
    name: "social-report-edit",
    path: "/social_reports/:reportId",
    props: true,
  },
  {
    component: () => import("pages/NewsSummaryList.vue"),
    meta: {
      title: "Daily Highlights",
    },
    name: "news-summaries-list",
    path: "/news-summaries",
  },
  {
    component: () => import("pages/NewsSummaryEdit.vue"),
    meta: {
      title: "New News Summary",
    },
    name: "news-summaries-new",
    path: "/news-summaries/new",
  },
  {
    component: () => import("pages/NewsSummaryEdit.vue"),
    meta: {
      title: "Edit News Summary",
    },
    name: "news-summaries-edit",
    path: "/news-summaries/:id",
    props: true,
  },
  {
    component: () => import("pages/insights/InsightsHomePage.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Media Analysis",
    },
    name: "insights",
    path: "/insights",
    props: (route) => ({
      view: route.query.view,
      ...route.params,
      ...route.query,
      reportType: "insights",
    }),
  },
  {
    component: () => import("pages/insights/InsightsHomePage.vue"),
    meta: {
      accessLevel: "media_analyst",
      title: "Insights Plus",
    },
    name: "insights-plus",
    path: "/insights-plus",
    props: (route) => ({
      view: route.query.view,
      ...route.params,
      ...route.query,
      reportType: "insights_plus",
    }),
  },
];
